/*
 * Delete-restaurant.ts
 * Description: Includes the declaration
 * of the function for deleting a restaurant
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';

/**
 * Deleting a restaurant
 *
 * @return {Object} Promise - deleted restaurant
 * @param {String} slug - id of a restaurant
 */
export function deleteRestaurant(slug: string) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug,
            method: 'delete',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}

/**
 * Deleting a delivery town in a restaurant
 *
 * @return {Object} Promise - deleted town
 * @param {String} ekatte - restaurant data
 * @param {String} slug - id of a restaurant
 */
export function deleteTown(slug: string, ekatte: string) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/towns/' + ekatte,
            method: 'delete',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
